namespace Client.Domain

open Leaflet
open Shared.Dto

[<RequireQualifiedAccess>]
module Location =
    let toLatLngExpression (location: Location) : LatLngExpression =
        LatLngExpression.Case3(location.Latitude, location.Longitude)